import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Crop = createReactComponent("Crop", ["svg", defaultAttributes, [["path", {
  d: "M6.13 1L6 16a2 2 0 002 2h15",
  key: "1gox95"
}], ["path", {
  d: "M1 6.13L16 6a2 2 0 012 2v15",
  key: "1c7eum"
}]]]);
export default Crop;